import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function MeetSara() {
  return <section className="w-full px-4 md:px-8 max-w-4xl mx-auto flex flex-col items-center py-8" data-id="element-158">
      <FadeIn className="text-center mb-10" data-id="element-159">
        <span className="text-amber font-lato uppercase tracking-widest text-sm font-bold mb-4 block" data-id="element-160">
          Who Is Behind This System?
        </span>
        <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-cream" data-id="element-161">
          Hi, I'm Sara.
        </h2>
      </FadeIn>

      <FadeIn delay={100} className="mb-10" data-id="element-162">
        <div className="w-40 h-40 rounded-full overflow-hidden border-[3px] border-amber mx-auto shadow-lg shadow-amber/10" data-id="element-163">
          <img src="https://cdn.magicpatterns.com/uploads/8kqxTE4Wc7y1cTDLW3ez92/SARA_(1).webp" alt="Sara, creator of Resin Without Errors" className="w-full h-full object-cover" data-id="element-164" />
        </div>
      </FadeIn>

      <FadeIn delay={200} className="max-w-2xl text-center flex flex-col gap-6 mb-10" data-id="element-165">
        <p className="font-lato text-cream/70 text-base md:text-lg leading-relaxed" data-id="element-166">
          I know exactly what it feels like to pour your heart into a resin
          piece — and watch it come out sticky, full of bubbles, or completely
          wrong. I wasted months and hundreds of dollars trying to figure it out
          on my own.
        </p>
        <p className="font-lato text-cream/70 text-base md:text-lg leading-relaxed" data-id="element-167">
          After failing over and over, I stopped guessing and built a system. A
          checklist before every pour. A protocol for every mistake. A method
          that works every single time — regardless of the brand, the weather,
          or your experience level.
        </p>
        <p className="font-lato text-cream/70 text-base md:text-lg leading-relaxed" data-id="element-168">
          I created Resin Without Errors™ because nobody should have to figure
          this out alone. Over 2,400 women have already used this system to make
          their first sell-ready piece. Now it's your turn.
        </p>
      </FadeIn>

      <FadeIn delay={300} data-id="element-169">
        <p className="text-amber font-lato text-sm md:text-base text-center tracking-wide" data-id="element-170">
          ⭐ 4.9/5 average rating · 2,400+ students · 30+ countries
        </p>
      </FadeIn>
    </section>;
}